import SetupHikGghyptSmsModal from './setup-hik-gghypt-sms-modal.vue'
export default SetupHikGghyptSmsModal
